module.exports = __webpack_public_path__ + "img/oddvega-logo-new-curve-hover.ff498aed.png";